import { store } from 'redux/store';
import { useEffect, useState } from 'react';
import { Document, Society } from 'types';
import { getDocument } from 'modules/documents/redux/documentActions';

type Props = {
  society: Society;
};

const useDocument = (society: Society) => {
  const [document, setDocument] = useState<Document>();

  useEffect(() => {
    const fetchDocument = async () => {
      const documentId = society?.templates?.sharesTitle;
      if (documentId) {
        const document = await store.dispatch(getDocument(documentId));
        setDocument(document);
      }
    };

    fetchDocument();
  }, [society]);

  return document;
};

export const useGetSocietySharesTitleDocument = ({ society }: Props) => {
  const document = useDocument(society);

  return {
    data: {
      document,
    },
  };
};
